import { navigateToHeydayPage, pageFromPathname, subscribeToHeydayLocation } from '../../config/heydayRoutes';
import type { AbsenceSettingsRoutePort, AbsenceSettingsView } from '../../features/absence/public';

function search(view: AbsenceSettingsView, typeId?: string) {
  const parameters = new URLSearchParams({ view: view === 'overview' || view === 'plans' ? 'types' : view });
  if (parameters.get('view') === 'types' && typeId?.trim()) parameters.set('type', typeId.trim());
  return parameters;
}

export const absenceSettingsRouteAdapter: AbsenceSettingsRoutePort = {
  read() {
    if (pageFromPathname(window.location.pathname) !== 'absence-settings') return 'types';
    const view = new URLSearchParams(window.location.search).get('view');
    return view === 'calendars' || view === 'setup' ? view : 'types';
  },
  readTypeId() {
    if (pageFromPathname(window.location.pathname) !== 'absence-settings') return undefined;
    const parameters = new URLSearchParams(window.location.search);
    return (!parameters.has('view') || parameters.get('view') === 'types')
      ? parameters.get('type')?.trim() || undefined
      : undefined;
  },
  navigate(view, options) {
    navigateToHeydayPage('absence-settings', search(view, options?.typeId), options);
  },
  subscribe: subscribeToHeydayLocation,
};
